import React, { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip, Typography, TypographyProps } from '@mui/material';

type Props = TypographyProps & {
  children: React.ReactNode;
};

export const EllipsisTooltipTypography = ({ children, ...props }: Props) => {
  const ref = useRef<HTMLElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const checkOverflow = () => {
      setIsOverflowing(element.scrollWidth > element.clientWidth);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [children]);

  return (
    <Tooltip title={isOverflowing ? children : ''} disableHoverListener={!isOverflowing}>
      <Typography
        ref={ref}
        {...props}
        sx={{
          display: 'block',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          ...props.sx
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};
